import * as dcfConf from '@/configuration/dcf/dcfConf';

export const ACTION_MASSE_RECEPTIONNER = 'actionMassReceptionner';
export const ACTION_MASSE_FACTURER = 'actionMassFacturer';

export const LISTE_INCLUSIONS_SUIVI_TACHES_INTERNES = [
  { value: dcfConf.INCLUSION_TIERS },
  { value: dcfConf.INCLUSION_LIGNE_COMMANDE },
  { value: dcfConf.INCLUSION_LIEU_DE_LIVRAISON },
  { value: dcfConf.INCLUSION_PRODUIT },
  { value: dcfConf.INCLUSION_ECHEANCIERS },
];
